import {omit} from 'lodash'
import {subdomainLink, viewerGuard} from '../../../helpers/url'
import React from 'react'
import {Link} from 'react-router-dom'
import {Consumer} from '../../../context'
import {faTrashAlt} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {deleteUploadedLesson} from '../../../context/post'
import confirmDialog from '../../confirm-dialog'
import 'react-confirm-alert/src/react-confirm-alert.css'
import Icon from '../../icon'

function LessonLink (props) {
  const {key, show, to, title, href} = props
  const linkProps = omit(props, ['key', 'show'])
  const LinkElem = to
    ? Link
    : ({children}) => (<a {...{...linkProps, ...viewerGuard(linkProps)}}>{children}</a>)
  return (
  <div key={key} className={key}>
    {show && <LinkElem {...linkProps}>
      <Icon name={key} />
    </LinkElem>}
    {!show && <span className="disabled">
      <Icon name={key} />
    </span>}
  </div>)
}

export default function UploadLinks (props) {
  const {name, id, assigned} = props
  return (<Consumer>{ context => {
    const {link, match, translations, languageId, profile} = context

    const zipName = `${name.replace(/.epl$/, '')}.zip`
    const {limited} = profile.institution
    const tooltipTitle = (name) => `${translations[`${name}_tooltip_title`][languageId]}: ${props.name}`
    const links = [
      { key: 'download',
        title: tooltipTitle('download'),
        show: !limited,
        ...viewerGuard({target: "_blank", href: subdomainLink('api-support', 'catalog',  'downloadUploaded', `?id=${id}`)}),
      },
      { key: 'schedule',
        title: tooltipTitle('schedule'),
        onClick: e => {
          if (!context.course) {
            e.preventDefault()
            context.setState({course: id.substring(0,6), selectedLesson: props}, () => {
              context.navigate({lesson: id}, `${context.match.path}/schedule/:lesson`, {preserveQuery: true})
            })
          }
        },
        show: !limited,
        to: link({lesson: id}, `${context.match.path}/schedule/:lesson`, {preserveQuery: true}) },
      { key: 'posts',
        title: tooltipTitle('posts'),
        show: (assigned > 0) && !limited,
        to: link({lesson: id}, `${context.match.path}/posts/:lesson`, {preserveQuery: true}) },
    ]
    return (
      <div className="links">
        {links.map(LessonLink)}
        <div
          className="link delete"
          onClick={ () =>
            confirmDialog({
              className: 'delete-upload',
              translate: context.translate,
              children: (
                <div className="message">
                  <div className="question">
                    {context.translate('confirm_delete_item')}
                  </div>
                  <div className="title">
                    {name}
                  </div>
                </div>
              ),
              onConfirm: async () => {
                await deleteUploadedLesson(id, name)
                const uploadUpdates = context.uploadUpdates + 1
                context.setState({uploadUpdates})
              }
            })
          }
        >
          <FontAwesomeIcon icon={faTrashAlt} />
        </div>
      </div>
    )
  }}</Consumer>)
}
